import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { OrderDetailResponseDTO, OrderListResponseDTO, OrdersQueryDTO } from '@libs/dtos/order/order.dto';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/** Orders query: the list filter sends platformId from a select (string) and filters by user name */
export type OrdersQueryParams = Partial<Omit<OrdersQueryDTO, 'platformId'>> & {
	platformId?: number | string;
	userName?: string;
};

@Injectable({
	providedIn: 'root',
})
export class OrdersService {
	private readonly baseUrl = `${environment.pathBackend}/orders`;

	constructor(private http: HttpClient) {}

	getOrderById(id: number | string): Observable<OrderDetailResponseDTO> {
		return this.http.get<OrderDetailResponseDTO>(`${this.baseUrl}/${id}`);
	}

	getOrders(params: OrdersQueryParams = {}): Observable<OrderListResponseDTO> {
		const {
			page = 1,
			limit = 10,
			sort_by,
			sort_order,
			paymentStatus,
			providerStatus,
			userId,
			include_user,
			include_product,
			include_platform,
			platformId,
			userName,
		} = params;

		let httpParams = new HttpParams().set('page', page.toString()).set('limit', limit.toString());

		if (sort_by) httpParams = httpParams.set('sort_by', sort_by);
		if (sort_order) httpParams = httpParams.set('sort_order', sort_order);
		if (paymentStatus) httpParams = httpParams.set('paymentStatus', paymentStatus);
		if (providerStatus) httpParams = httpParams.set('providerStatus', providerStatus);
		if (userId) httpParams = httpParams.set('userId', userId.toString());
		if (include_user !== undefined) httpParams = httpParams.set('include_user', include_user.toString());
		if (include_product !== undefined) httpParams = httpParams.set('include_product', include_product.toString());
		if (include_platform !== undefined)
			httpParams = httpParams.set('include_platform', include_platform.toString());
		if (platformId) httpParams = httpParams.set('platformId', platformId);
		if (userName) httpParams = httpParams.set('userName', userName);

		return this.http.get<OrderListResponseDTO>(this.baseUrl, { params: httpParams }).pipe(
			catchError(() => {
				return throwError(() => new Error('Failed to load orders'));
			}),
		);
	}
}
